module.exports = __webpack_public_path__ + "static/img/MR技术系统开发.681a8ee1.png";